import { Fragment, FC, JSX } from 'react';
import { Box, Grid, IconButton, Typography, Tooltip } from '@mui/material';
import {
  CircleRounded as CircleRoundedIcon,
  Undo as UndoIcon,
  Clear as CloseIcon,
} from '@mui/icons-material';
// interfaces
import { ingredientsBlendProps } from 'interfaces';
import { deleteButtonStyles, undoButtonStyles } from 'styles/commonComponentStyle';
const IngredientBlends: FC<ingredientsBlendProps> = ({
  ingredientsBlend,
  onBlendAdd,
  onUnblend,
}): JSX.Element => {
  const onBlendDelete = (blendName: string) => {
    const data = ingredientsBlend?.filter(({ name }) => name !== blendName);
    onBlendAdd(data);
  };

  const handleUnblend = (blendName: string, blendIngredients: any[]) => {
    onUnblend(blendName, blendIngredients);
    // Remove the blend from the blend list
    const updatedBlends = ingredientsBlend?.filter(({ name }) => name !== blendName);
    onBlendAdd(updatedBlends);
  };

  return (
    <Grid container spacing={2}>
      {ingredientsBlend?.map((item) => {
        const { name, ingredients } = item;
        return (
          <Fragment key={name}>
            <Grid item xl={10} lg={10} md={10} sm={10} xs={10}>
              <Box
                flex={1}
                padding={2}
                display="flex"
                borderRadius={1}
                alignItems="center"
                bgcolor={'primary.main'}>
                <Box flex={1}>
                  <Typography variant="caption">{name}</Typography>
                  <Box>
                    {ingredients?.map(({ ingredientId, name }) => (
                      <Box key={ingredientId} display="flex" alignItems="center" mt={1}>
                        <CircleRoundedIcon fontSize="small" />
                        <Typography ml={1} variant="caption">
                          {name}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Box>
            </Grid>
            <Grid item xl={2} xs={2} display="flex" alignItems="center" justifyContent="center">
              <Box display="flex" flexDirection="row" gap={1}>
                <Tooltip title="Unblend">
                  <IconButton
                    onClick={() => handleUnblend(name, ingredients)}
                    size="small"
                    sx={undoButtonStyles}>
                    <UndoIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Delete Blend">
                  <IconButton onClick={() => onBlendDelete(name)} size="small" sx={deleteButtonStyles}>
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </Box>
            </Grid>
          </Fragment>
        );
      })}
    </Grid>
  );
};

export default IngredientBlends;
